<template>
    <div>
        <el-dialog :visible="visible" :title="hoursTitle" width="900px" @close="$emit('close')"
            :close-on-click-modal="false">
            <div class="editHours">
                <el-table :data="tableData" height="300px">
                    <el-table-column property="tt_id" label="ID" width="150" />
                    <el-table-column property="tt_coding_start_date" label="日期" width="150" />
                    <el-table-column property="tt_coding_time" label="工时" width="200" />
                    <el-table-column property="remark" label="备注" />
                    <el-table-column fixed="right" label="操作" align="center">
                        <template slot-scope="{row}">
                            <el-button type="text" size="mini" @click="editHoursData(row)">编辑</el-button>
                            <el-button type="text" size="mini" @click="deleteHours(row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="$emit('close')">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="showEditModal" title="编辑工时表单" :close-on-click-modal="false">
            <el-form :model="hoursDataForm">
                <el-form-item :label-width="formLabelWidth" label="日期">
                    <el-date-picker disabled v-model="hoursDataForm.tt_coding_start_date" value-format="yyyy-MM-dd"
                        type="date" placeholder="选择日期" style="width:400px;" />
                </el-form-item>
                <el-form-item :label-width="formLabelWidth" label="消耗工时">
                    <el-input-number :max="12" :min="0.1" :step="0.1" @blur="changeHours" @input.native="inputHours"
                        v-model.number="hoursDataForm.tt_coding_time" style="width:400px;" />
                </el-form-item>
                <el-form-item :label-width="formLabelWidth" label="备注">
                    <el-input v-model="hoursDataForm.remark" style="width:400px;" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showEditModal = false">取 消</el-button>
                <el-button type="primary" @click="submitHoursData" :loading="submitLoading">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from '../mixin'
import { getDefectWorkList, updateDefectWork,deleteDefectWork } from '@/api/defectManagement'
import { mapGetters } from 'vuex'
export default {
    mixins: [mixin],
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        hoursTitle: {
            type: String,
            default: ''
        },
        currentItem: {
            type: Object,
            default: () => ({})
        },
    },
    computed: {
        ...mapGetters(['userId'])
    },
    watch: {
        visible(val) {
            if (val) {
                this.getHoursList()
            }
        }
    },
    data() {
        return {
            hoursDataForm: {
                tt_id: '',
                tt_coding_start_date: '',
                tt_coding_time: '',
                remark: '',
            },
            showEditModal: false,
            submitLoading: false,
            formLabelWidth: '120px',
            tableData: [],
        }
    },
    methods: {
        editHoursData(rowdata) {
            this.showEditModal = true
            this.hoursDataForm.tt_id = rowdata.tt_id
            this.hoursDataForm.tt_coding_start_date = rowdata.tt_coding_start_date
            this.hoursDataForm.tt_coding_time = rowdata.tt_coding_time
            this.hoursDataForm.remark = rowdata.remark
        },
        // 删除工时
        deleteHours(rowdata) {
            this.$confirm('此操作将永久删除该工时, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const params = {
                    tb_id: this.currentItem.tb_id,
                    role: this.currentItem.role,
                    data:[
                        {
                            tt_id: rowdata.tt_id,
                            times: rowdata.tt_coding_time,
                            date: rowdata.tt_coding_start_date,
                            remark: rowdata.remark,
                        }
                    ],
                    user_id: this.userId
                }
                await deleteDefectWork(params)
                this.$message({
                    message: '删除成功',
                    type: 'success'
                })
                this.getHoursList()
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        async submitHoursData() {
            try {
                this.submitLoading = true
                const params = {
                    tb_id: this.currentItem.tb_id,
                    role: this.currentItem.role,
                    data:[
                        {
                            tt_id: this.hoursDataForm.tt_id,
                            times: this.hoursDataForm.tt_coding_time,
                            date: this.hoursDataForm.tt_coding_start_date,
                            remark: this.hoursDataForm.remark,
                        }
                    ],
                    user_id: this.userId
                }
                await updateDefectWork(params).finally(() => {
                    this.submitLoading = false
                })
                this.$message({
                    message: '编辑工时成功',
                    type: 'success'
                })
                this.submitLoading = false
                this.showEditModal = false
                this.getHoursList()
            } catch (error) {
                this.submitLoading = false
                console.error(error)
            }
        },
        changeHours(val) {
            // 超过12 或者小于0，提示 一天工时不允许超过12小时
            if (this.inputHourValue > 12 || this.inputHourValue < 0) {
                this.$message({
                    type: "warning",
                    message: "一天工时不允许超过12小时和小于1小时"
                });
            }
        },
        inputHours(val) {
            this.inputHourValue = val.target.value;
        },
        // 获取工时列表
        async getHoursList() {
            const params = {
                tb_id: this.currentItem.tb_id,
                role: this.currentItem.role,
                user_id: this.userId,
            }
            const { data } = await getDefectWorkList(params)
            this.tableData = data
        },
    }
}
</script>
